import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { db } from "../firebase/firebase"; // ✅ Firestore import
import { doc, setDoc } from "firebase/firestore"; // ✅ Firestore import
import "./styles/Signup.css";

const Signup = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);

  const { signUp } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (password.length < 3) {
      setError("Password must be at least 3 characters long.");
      return;
    }

    try {
      const userCredential = await signUp(email, password);
      const user = userCredential.user;

      // Profile writes may be restricted by production Firestore rules; auth is enough for StormOps ownership.
      if (db) {
        try {
          await setDoc(doc(db, "users", user.uid), {
            firstName,
            lastName,
            email: user.email,
            createdAt: new Date()
          });
        } catch (profileError) {
          console.warn("StormOps profile save skipped:", profileError.message);
        }
      }

      console.log("✅ Signup successful");
      navigate("/dashboard");
    } catch (error) {
      console.error("❌ Signup error:", error.message);
      setError("Signup failed: " + error.message);
    }
  };

  return (
    <div className="signup-page">
      <div className="signup-container">
        <h2 className="signup-title">Create your account</h2>

        {error && <div className="signup-error">{error}</div>}

        <form onSubmit={handleSubmit} className="signup-form">
          <div className="name-fields">
            <input
              type="text"
              placeholder="First name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              className="signup-input half"
              required
            />
            <input
              type="text"
              placeholder="Last name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              className="signup-input half"
              required
            />
          </div>

          <input
            type="email"
            placeholder="Work email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="signup-input"
            required
          />

          <input
            type="password"
            placeholder="Password ( Min. 3 characters )"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="signup-input"
            required
          />

          <button type="submit" className="signup-button">Create account</button>
        </form>

        <div className="signup-text">
          Already have an account? <Link to="/login">Log in</Link>
        </div>

        <div className="signup-disclaimer">
          By continuing you agree to the <Link to="/terms-of-service">Terms of use</Link> and <Link to="/privacy-policy">Privacy policy</Link>.
        </div>
      </div>
    </div>
  );
};

export default Signup;
